import { Helmet } from "react-helmet-async";
import {useLocation} from "react-router-dom";
import React from "react";

export default function SEO({
    title,
    description,
    image,
    type = "website",
}) {
    const siteUrl = "https://autorecparts.gr";

    const location = useLocation();
    const pathname = location.pathname;
    const canonicalUrl = `${window.location.origin}${pathname}`;

    return (
        <Helmet>

            <title>{title}</title>
            <meta name="description" content={description} />
            <meta http-equiv="X-UA-Compatible" content="IE=edge" />
            <link rel="canonical" href={canonicalUrl} />

            {/* Open Graph */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            {image && <meta property="og:image" content={image} />}
            <meta property="og:url" content={canonicalUrl} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            {image && <meta name="twitter:image" content={image} />}
        </Helmet>
    );
}
